import Link from "next/link";

import { Anchor } from "@newsela/angelou";
import { useRouter } from "next/router";

import {
  activeLinkCss,
  linkContainerCss,
  linkCss,
} from "./ContentPromotionFormLinks.style";

interface ContentPromotionFormLinkAttributes {
  href: string;
  text: string;
}
interface ContentPromotionFormLinksProps {
  links: ContentPromotionFormLinkAttributes[] | undefined;
}

const ContentPromotionFormLinks = ({
  links,
}: ContentPromotionFormLinksProps) => {
  const { asPath } = useRouter();

  if (!links || links.length === 1) return <></>;

  const isActiveLink = (linkHref: string) => {
    return linkHref === asPath;
  };

  return (
    <div css={linkContainerCss}>
      {links.map(({ href, text }) => (
        <Link href={href} passHref legacyBehavior shallow key={href}>
          <Anchor
            __cssFor={{
              root: [linkCss, isActiveLink(href) && activeLinkCss],
            }}
            dataProps={{
              "data-qa-selector": `${text}-filter-chip`,
            }}
          >
            {text}
          </Anchor>
        </Link>
      ))}
    </div>
  );
};

export default ContentPromotionFormLinks;
